export default __webpack_public_path__ + "static/access-control-lp-video-min-6a64fdd4a8336dd310d2c80084ee06a8.mp4";